<div class="direct-debit">
    <router-outlet></router-outlet>
</div>
<max-loader *ngIf="loader"></max-loader>